export default __webpack_public_path__ + "static/media/custom_screen.44210457.jpg";